import { RootStore, RootStoreModel } from "./RootStore";
import { Environment } from "../environment";

/**
 * Setup the environment that all the models will be sharing.
 *
 * The environment includes other functions that will be picked from some
 * of the models that get created later. This is how we loosly couple things
 * like events between models.
 */
const createEnvironment = async () => {
  const env = new Environment();
  await env.setup();
  return env;
};

/**
 * Setup the root state.
 */
export async function setupRootStore(
  snapshot: Parameters<typeof RootStoreModel.create>[0]
) {
  let rootStore: RootStore;

  // prepare the environment that will be associated with the RootStore.
  const env = await createEnvironment();
  try {
    rootStore = RootStoreModel.create(snapshot, env);
  } catch (e) {
    // if there's any problems loading, then let's at least fallback to an empty state
    // instead of crashing.
    rootStore = RootStoreModel.create({}, env);

    console.error(e);
  }

  return rootStore;
}
